import { render, staticRenderFns } from "./PlanCommunicationTile.vue?vue&type=template&id=530f547e&scoped=true&"
import script from "./PlanCommunicationTile.vue?vue&type=script&lang=js&"
export * from "./PlanCommunicationTile.vue?vue&type=script&lang=js&"
import style0 from "./PlanCommunicationTile.vue?vue&type=style&index=0&id=530f547e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530f547e",
  null
  
)

export default component.exports